var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 4,
    viewBox: "0 0 12 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.9998C0 1.68154 0.126428 1.37632 0.351472 1.15128C0.576516 0.926233 0.88174 0.799805 1.2 0.799805H10.8C11.1183 0.799805 11.4235 0.926233 11.6485 1.15128C11.8736 1.37632 12 1.68154 12 1.9998C12 2.31806 11.8736 2.62329 11.6485 2.84833C11.4235 3.07338 11.1183 3.1998 10.8 3.1998H1.2C0.88174 3.1998 0.576516 3.07338 0.351472 2.84833C0.126428 2.62329 0 2.31806 0 1.9998Z",
    fill: "#06D6A0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minusIcon.f2ecb5eeaa5497b5f292c651421bc584.svg";
export { ForwardRef as ReactComponent };